import { useSelector } from 'react-redux';

// Resolve a single master-data label in the currently active language.
// The lookup hits a tiny redux selector so components only re-render when THEIR
// specific (moduleName, entityId, field) combination changes — not on every other
// translation update or language switch that doesn't touch their cell.
//
// Usage:
//   const name = useMasterLabel('masterSpecialty', spec.specialtyId, 'name', spec.name);
//   <h3>{name}</h3>
//
// If the cached locale doesn't have a translation for this cell, the fallback is
// returned instead (usually the English value already baked into the API response).
export const useMasterLabel = (moduleName, entityId, field, fallback = '') => {
    const value = useSelector((state) => {
        const tree = state.translation?.masterLocaleTree;
        if (!tree || !moduleName || !entityId || !field) return undefined;
        return tree?.[moduleName]?.[entityId]?.[field];
    });

    if (value === undefined || value === null || value === '') return fallback;
    return value;
};

// Bulk variant: resolves every field of a single master entity at once. Prefer this
// when a card renders 3+ fields from the same entity — one selector call instead of three.
export const useMasterEntity = (moduleName, entityId, fallback = {}) => {
    const entity = useSelector((state) => state.translation?.masterLocaleTree?.[moduleName]?.[entityId]);
    if (!entity) return fallback;
    return { ...fallback, ...entity };
};
